import DateUtils from "@plannel/utils/date-util";
import debug from "@plannel/utils/debug-util";
import {t} from "i18next";
import {isBoolean, isEmpty, isNil, isNull } from "lodash";
import NumberUtil from "@plannel/utils/number-util";

const nameFormatter = title => {
  return (title.replace(/\s/gi, "_")).toLowerCase();
}

const makeFileName = title => {
  return isEmpty(title) ? "plannel" : `plannel_${nameFormatter(t(title))}_${DateUtils.formatDate(new Date(), "yyyy-MM-dd_HH-mm-ss")}`;
}

const makeSheetName = title => {
  return isEmpty(title) ? "plannel" : t(title);
}

const EXPORT_FAIL_CELL = "Fail to Export Cell Value";
const defaultReturnValue = (params) => {
  const value = params?.value;

  if (isNil(value) || isEmpty(value)) {
    return null;
  }

  if (!isEmpty(value) && typeof value === "string") {
    return value;
  }
  
  if (!isEmpty(value) && value?.name) {
    if (typeof value !== "object") {
      return value;
    }
    return value.name;
  }

  if (isBoolean(value)) {
    return value;
  }

  return EXPORT_FAIL_CELL;
}

// 우선순위 valueGetter > valueFormatter > cellRenderer
const processExportCell = (params) => {
  try {
    const colObj = params.column.getColDef();
    const cellValue = params?.value;

    /* booleanColumn인 경우 바로 return */
    if (colObj?.type && colObj.type.includes("booleanColumn")) {
      return cellValue;
    } else if (colObj?.valueGetter && cellValue) {
      if (!isNaN(cellValue)) {
        return Number(NumberUtil.formatNumber(cellValue, { maximumFractionDigits: 4, minimumFractionDigits: 4 }).replace(/,/gi, ""));
      }
        return cellValue;
    } else if (colObj?.type && (colObj.type.includes("percentColumn"))) {
      if (isNull(cellValue) || isNaN(cellValue)) {
        return null;
      }
      const value = Number(NumberUtil.formatNumber(cellValue, { maximumFractionDigits: 3, minimumFractionDigits: 3 }).replace(/,/gi, ""));
      colObj.cellClass = !isNaN(value) && !Number.isInteger(value) ? 'flexibleDecimalType' : null;
      return value;
    } else if (colObj?.type && colObj.type.includes("detailPercentColumn")) {
      if (isNull(cellValue) || isNaN(cellValue)) {
        return null;
      }
      const value = Number(NumberUtil.formatNumber(cellValue, { maximumFractionDigits: 5, minimumFractionDigits: 5 }).replace(/,/gi, ""));
      colObj.cellClass = !isNaN(value) && !Number.isInteger(value) ? 'flexibleDecimalType' : null;
      return value;
    } else if (colObj?.valueFormatter) {
      const exportParams = {
          data: params.node.data,
          colDef: colObj
      };
      if (colObj.valueFormatter.customType === "excelExport") {
        const rawValue = colObj.valueFormatter(exportParams, true);
        if (isNull(rawValue) || isNaN(rawValue) || rawValue === "") {
          return null;
        }
        const formatValue = typeof rawValue === "string" ? Number(rawValue.replace(/,/g, "")) : Number(rawValue);
        colObj.cellClass = !Number.isInteger(formatValue) ? 'flexibleDecimalType' : null;

        return formatValue;
      }

      const formatValue = colObj.valueFormatter(params);
      if (typeof formatValue === "number") {
        return formatValue;
      } else if (typeof formatValue === "object") {
        return null;
      }

      if (isNull(formatValue) || formatValue === ""){
        return null;
      }
    
      return formatValue && formatValue?.includes(",") ? formatValue.replace(/,/gi, "") : formatValue;
    } else if (colObj?.cellRenderer) {
      /* AG-Grid가 지정해놓은 Renderer 인 경우 (type == String) */
      if (typeof (colObj.cellRenderer) !== "string") {
        const rendered = colObj.cellRenderer(params);

        if (!isNull(rendered) && typeof rendered === "object") {
          return cellValue;
        }

        return rendered;
      }
    }

    return cellValue;
  } catch (e) {
    debug("Excel Export processExportCell UnKnown Error:", e);

    return defaultReturnValue(params);
  }
  
}

const processRowGroupCallback = (params) => {
  return params.node.key;
}

const defaultExcelExportParams = (title) => {
  return {
    autoConvertFormulas: true,
    fileName: `${makeFileName(title)}.xlsx`,
    sheetName: makeSheetName(title),
    processCellCallback: params => processExportCell(params),
    processRowGroupCallback: params => processRowGroupCallback(params)
  }
}

const defaultCsvExportParams = (title) => {
  return {
    fileName: `${makeFileName(title)}.csv`,
    sheetName: makeSheetName(title),
    processCellCallback: params => processExportCell(params)
  }
}


const GridExportSetting = {
  makeFileName,
  processExportCell,
  defaultExcelExportParams,
  defaultCsvExportParams,
}

export default GridExportSetting;